import { DateOrTime, Flex, IconButton, PencilSquareIcon, Text, UserAvatar } from 'components'
import { useBreakpoint, useUser } from 'utils'
import { RegistrationConsentRecord } from '../../utils/registrationConsentUtils'

interface Props {
  consent: RegistrationConsentRecord
  onEdit?: () => void
}

export default function RegistrationConsentTileViewer({ consent, onEdit }: Props) {
  const breakpoint = useBreakpoint()
  const consentCreator = useUser(consent?.createdBy)

  return breakpoint > 3 ? (
    <Flex width="100%" align="center" gap={3}>
      <Flex direction="column" justify="center" flex={1} minWidth={0}>
        <Text textStyle="bodyMedium" as="p">
          {consent?.title}
        </Text>
      </Flex>
      <Flex align="center" gap={3} flexShrink={0}>
        <Flex align="center" width="200px" gap={3}>
          <UserAvatar user={consentCreator} />
          <Text {...readOnlyTextProps}>{consentCreator?.displayName}</Text>
        </Flex>
        <DateOrTime {...readOnlyTextProps} width="120px">
          {consent?.updated}
        </DateOrTime>
        {onEdit && (
          <IconButton aria-label="edit consent" icon={<PencilSquareIcon />} onClick={onEdit} />
        )}
      </Flex>
    </Flex>
  ) : (
    <Flex align="center" gap={3} width="100%">
      <Flex direction="column" justify="center" flex={1} minWidth={0}>
        <Text textStyle="bodyMedium" as="p">
          {consent?.title}
        </Text>
      </Flex>
      {onEdit && (
        <IconButton aria-label="edit consent" icon={<PencilSquareIcon />} onClick={onEdit} />
      )}
    </Flex>
  )
}

const readOnlyTextProps = {
  textStyle: 'bodySmall' as const,
}
